import axios from 'axios';

export const validateCompany = async (queryParams) => {
  const { data } = await axios.put('/users/company-association-validation', queryParams);

  return data;
};
